import React from 'react';

import PaymentMethodContainer from './PaymentMethod/PaymentMethod.container';

const PaymentMethods = () => <PaymentMethodContainer />;

export default PaymentMethods;
